/** Created by azhou on 2019/3/19.*/
<template>
  <div>
    <ul class="list-item">
        <li class="w-50 list-item-col">{{(Itemize.ticket_species || Itemize.species) | formatVar('ticketTypeArr')}}</li>
        <li class="w-50 list-item-col">{{Itemize.name}}</li>
        <li class="w-50 list-item-col flex-column">
            <label class="text-muted">门市价 / <span class="text-blue">{{Itemize.price1}}</span> 元</label>
            <label class="text-muted">{{brand ? '采购商价' : '网络价'}} / <span class="text-blue">{{Itemize.price2}}</span> 元</label>
            <label class="text-muted">{{brand ? '订单雨价' : '采购商价'}} / <span class="text-blue">{{Itemize.price3}}</span> 元</label>
        </li>
        <li class="w-50 list-item-col">
            <div v-if="brand" :class="Itemize.status==0 ? 'text-danger' : 'text-success'">{{Itemize.status==0 ? '已下架' : '已上架'}}</div>
            <div v-else :class="Itemize.is_verify==0 ? 'text-danger' : 'text-success'">{{Itemize.is_verify==0 ? '待审核' : '已审核'}}</div>
        </li>
        <li class="w-50 list-item-col-end">
            <span v-if="brand">{{Itemize.create_time | formatTimestamp(1)}}</span>
            <span v-else class="text-link mr-2" @click="Seek(Itemize.id,Itemize.store_id)">查看</span>
        </li>
    </ul>
    <el-dialog
        :title="'状态:'+Status"
        :visible.sync="dialogVisible">
        <p class="d-center-start mb-2">
            <left-text leftText="门票类别"/><span class="ml-1">散客门票</span>
        </p>
        <div class="d-center-start mb-2">
            <left-text leftText="票种"/><p>{{Itemize.ticket_species | formatVar('ticketTypeArr')}}</p>
        </div>
        <div class="d-start-start mb-2">
            <left-text leftText="门票名称"/><p>{{ticketDetail.name}}</p>
        </div>
        <div class="d-start-start mb-2">
            <left-text leftText="价格"/>
            <span class="mr-2">门市价:{{ticketDetail.price1}}</span>
            <span class="mr-2">网络价:{{ticketDetail.price2}}</span>
            <span class="mr-2">采购商价:{{ticketDetail.price3}}</span>
        </div>
        <div class="d-start-start mb-2">
            <left-text leftText="费用包含"/><p>{{ticketDetail.description1}}</p>
        </div>
        <div class="d-start-start mb-2">
            <left-text leftText="入园方式"/><p>{{ticketDetail.description2}}</p>
        </div>
        <div class="d-start-start mb-2">
            <left-text leftText="重要提示"/><p>{{ticketDetail.description3}}</p>
        </div>
        <div class="d-start-start mb-2">
            <left-text leftText="退改规则"/><p>{{ticketDetail.description4}}</p>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
        </span>
    </el-dialog>
    <!-- <el-pagination background layout="prev, pager, next" class="mt-4"
                    :total="StoreTicketList.total" :current-page="Number(queryCon.page)"
                    @current-change="v => this.currentPage=v"/> -->
  </div>
</template>

<script>
    import { mapState, mapActions} from 'vuex'
  export default {
    name: 'TicketNum',
    props:{
      Itemize:{}
    },
    data () {
        return {
            dialogVisible: false
        }
    },
    computed: {
        ...mapState(['ticketDetail']),
        Status () {
            switch (this.ticketDetail.is_verify) {
                case '0': return '待审核';break;
                case '1': return '已审核';break;
            }
        },
        brand () {
            return this.$route.query.type == 8
        }
    },
    methods: {
        ...mapActions(['getTicketDetail']),
        Seek (ticketId) {
            this.getTicketDetail(ticketId)
            this.dialogVisible = true
        }
    }
  }
</script>
